module.exports = __webpack_public_path__ + "img/vaginal-kit-box.9b497f1a.svg";